export default __webpack_public_path__ + "static/media/SDG Wheel_Transparent_WEB.7827eed7.png";